module.exports = __webpack_public_path__ + "img/w-profile-vip.c26d248d.svg";